export default class {
   mobileMenuButton = document.querySelector('.js_toggle-mobile-menu');
   header = document.querySelector('.header');

   constructor() {
       this.listen();
   }

   listen() {
      this.mobileMenuButton.addEventListener('click', (event) => {
         event.stopPropagation();
         this.mobileMenuButton.classList.toggle('open');
         this.header.classList.toggle('open-menu');
         document.body.classList.toggle('ovhidden');
      })
   }
}
